import React, { useState } from "react";
import {CustomButton2, CustomInput, CustomTimePiker, CustomView} from "../../../../../../components";
import type { ITiming, IWeeksDay, ICreateStudent } from "../../../../../../types/student.interface";
import DayInformation from "./DayInformation";
import { useFormik } from "formik";
import * as Yup from "yup";
import validations from "../../../../../../validations";
import utils from "../../../../../../utils";

type Props = {
  defaultValue: any;
  onSubmit: (arg: ICreateStudent) => void;
  onBack: (arg: ICreateStudent) => void;
};

const StudentTiming = (props: Props) => {
  const [expireDate, setExpireDate] = useState<string | undefined>(
      props?.defaultValue?.expire?.toString() || new Date(2025, 8, 23).toString()
  );

  const [errors, setErrors] = useState({
    expireDate: "",
    timing: {
      friday: "",
      sunday: "",
      monday: "",
      tuesday: "",
      thursday: "",
      saturday: "",
      wednesday: "",
    },
  });

  const timingSchool = props.defaultValue.school?.grade?.find(
    (item: any) => item.grade === props.defaultValue.grade?._id
  );

  const pickupHour  : number = Number(timingSchool?.entranceTime?.substr(11, 2)?.padStart(2, "0"));
  const pickupMinute: number = Number(timingSchool?.entranceTime?.substr(14, 2)?.padStart(2, "0")) - 30;

  const defaultTiming = {
    entranceTime: {
      hour  : timingSchool?.entranceTime?.substr(11, 2)?.padStart(2, "0"),
      minute: timingSchool?.entranceTime?.substr(14, 2)?.padStart(2, "0"),
    },
    departTime: {
      hour  : timingSchool?.departTime?.substr(11, 2)?.padStart(2, "0"),
      minute: timingSchool?.departTime?.substr(14, 2)?.padStart(2, "0"),
    },
    pickupTime: {
      hour  : pickupMinute < 0 ? (pickupHour   - 1 ).toString() : isNaN(pickupHour  ) ? undefined : pickupHour  ,
      minute: pickupMinute < 0 ? (pickupMinute + 60).toString() : isNaN(pickupMinute) ? undefined : pickupMinute,
    },
  };
  const [timing, setTiming] = useState<ITiming>({
    sunday   : props.defaultValue?.timing?.sunday    ?? { close: false, ...defaultTiming },
    friday   : props.defaultValue?.timing?.friday    ?? { close: true , ...defaultTiming },
    monday   : props.defaultValue?.timing?.monday    ?? { close: false, ...defaultTiming },
    tuesday  : props.defaultValue?.timing?.tuesday   ?? { close: false, ...defaultTiming },
    saturday : props.defaultValue?.timing?.saturday  ?? { close: false, ...defaultTiming },
    thursday : props.defaultValue?.timing?.thursday  ?? { close: true , ...defaultTiming },
    wednesday: props.defaultValue?.timing?.wednesday ?? { close: false, ...defaultTiming },
  });

  function onSubmitBack() {
    props.onBack({
      ...props.defaultValue,
      timing,
      expire: expireDate,
      price: formik.values.price,
    });
  }

  const formik = useFormik<ICreateStudent>({
    enableReinitialize: true,
    initialValues: {
      ...props?.defaultValue,
      price: props?.defaultValue?.price ?? '0',
    },
    validationSchema: Yup.object({
      price: validations.yupValidations.price,
    }),
    onSubmit: (values: ICreateStudent, { setSubmitting }) => {
      const formValues: ICreateStudent = {
        ...values,
        price: utils.convertPriceToNumber(values?.price as string).toString(),
        expire: expireDate,
        timing,
      };
      // if (expireDate) {
        Promise.resolve(props.onSubmit(formValues)).catch(() =>
          setSubmitting(false)
        );
      // }
    },
  });

  const submitHandler = () => {
    let errors = {
      expireDate: "",
      timing: {
        friday: "",
        saturday: "",
        sunday: "",
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
      },
    };
    // if (!expireDate) {
    //   errors = {
    //     ...errors,
    //     expireDate: "لطفا تاریخ پایان قرارداد را انتخاب نمایید",
    //   };
    // }
    // if (!timing.friday?.close) {
    //   errors = {
    //     ...errors,
    //     timing: {
    //       ...errors.timing,
    //       friday: "لطفا وضعیت روز جمعه را مشخص کنید",
    //     },
    //   };
    // }
    // if (!timing.saturday?.close) {
    //   errors = {
    //     ...errors,
    //     timing: {
    //       ...errors.timing,
    //       saturday: "لطفا وضعیت روز  شنبه را مشخص کنید",
    //     },
    //   };
    // }
    // if (!timing.monday?.close) {
    //   errors = {
    //     ...errors,
    //     timing: {
    //       ...errors.timing,
    //       monday: "لطفا وضعیت روز دوشنبه را مشخص کنید",
    //     },
    //   };
    // }
    // if (!timing.tuesday?.close) {
    //   errors = {
    //     ...errors,
    //     timing: {
    //       ...errors.timing,
    //       tuesday: "لطفا وضعیت روز سه شنبه را مشخص کنید",
    //     },
    //   };
    // }
    // if (!timing.wednesday?.close) {
    //   errors = {
    //     ...errors,
    //     timing: {
    //       ...errors.timing,
    //       wednesday: "لطفا وضعیت روز چهارشنبه را مشخص کنید",
    //     },
    //   };
    // }
    // if (!timing.thursday?.close) {
    //   errors = {
    //     ...errors,
    //     timing: {
    //       ...errors.timing,
    //       thursday: "لطفا وضعیت روز پنج شنبه را مشخص کنید",
    //     },
    //   };
    // }
    // if (!timing.sunday?.close) {
    //   errors = {
    //     ...errors,
    //     timing: {
    //       ...errors.timing,
    //       sunday: "لطفا وضعیت روز یک شنبه را مشخص کنید",
    //     },
    //   };
    // }
    setErrors(errors);
    formik.submitForm();
  };

  return (
    <CustomView.Container className="create-form-content scroll-y">
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum">
          <CustomInput
            name="price"
            id="price"
            label="قیمت سرویس (تومان)"
            value={
              utils.convertPriceToNumber(formik.values.price as string)
                ? utils.convertNumberToPrice(
                    utils.convertPriceToNumber(formik.values.price as string)
                  )
                : formik.values.price?.slice(0, -1)
            }
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.price && formik.touched.price}
            errorText={formik.errors.price}
          />
        </CustomView.Column>
        <CustomView.Column className="form-colum dropdown">
          <div style={{ zIndex: 100000 }}>
            <label className="form-label">تاریخ شروع سرویس</label>
            <CustomTimePiker
              defaultValue={expireDate}
              onChange={(event: string) => {
                setErrors({
                  ...errors,
                  expireDate: "",
                });
                setExpireDate(event);
              }}
              // minDate={new Date()}
            />
            <div className="error">
              {errors.expireDate !== "" && errors.expireDate}
            </div>
          </div>
        </CustomView.Column>
      </CustomView.Row>
      <hr />
      {/* ==================================================== SATURDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.saturday}
        onChange={(event: IWeeksDay) => {
          {
            setTiming!({ ...timing, saturday: event });
          }
          setErrors((prev) => ({
            ...prev,
            timing: { ...prev.timing, saturday: "" },
          }));
        }}
        label="شنبه"
        error={errors.timing.saturday}
      />
      {/* ==================================================== SUNDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.sunday}
        onChange={(event: IWeeksDay) => {
          setTiming!({ ...timing, sunday: event });
          setErrors((prev) => ({
            ...prev,
            timing: { ...prev.timing, sunday: "" },
          }));
        }}
        label="یک شنبه"
        error={errors.timing.sunday}
      />
      {/* ==================================================== MONDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.monday}
        onChange={(event: IWeeksDay) => {
          setTiming!({ ...timing, monday: event });
          setErrors((prev) => ({
            ...prev,
            timing: { ...prev.timing, monday: "" },
          }));
        }}
        label="دوشنبه"
        error={errors.timing.monday}
      />
      {/* ==================================================== TUESDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.tuesday}
        onChange={(event: IWeeksDay) => {
          setTiming!({ ...timing, tuesday: event });
          setErrors((prev) => ({
            ...prev,
            timing: { ...prev.timing, tuesday: "" },
          }));
        }}
        label="سه شنبه"
        error={errors.timing.tuesday}
      />
      {/* =================================================== WEDNESDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.wednesday}
        onChange={(event: IWeeksDay) => {
          setTiming!({ ...timing, wednesday: event });
          setErrors((prev) => ({
            ...prev,
            timing: { ...prev.timing, wednesday: "" },
          }));
        }}
        label="چهارشنبه"
        error={errors.timing.wednesday}
      />{" "}
      {/* =================================================== THURSDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.thursday}
        onChange={(event: IWeeksDay) => {
          setTiming!({ ...timing, thursday: event });
          setErrors((prev) => ({
            ...prev,
            timing: { ...prev.timing, thursday: "" },
          }));
        }}
        label="پنج شنبه"
        error={errors.timing.thursday}
      />
      {/* ==================================================== FRIDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.friday}
        onChange={(event: IWeeksDay) => {
          setTiming!({ ...timing, friday: event });
          setErrors((prev) => ({
            ...prev,
            timing: { ...prev.timing, friday: "" },
          }));
        }}
        label="جمعه"
        error={errors.timing.friday}
      />
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum" medium={6}>
          <CustomButton2 onClick={onSubmitBack} title="قبلی" type="danger" />
        </CustomView.Column>
        <CustomView.Column className="form-colum" medium={6}>
          <CustomButton2 onClick={submitHandler} title="ثبت" />
        </CustomView.Column>
      </CustomView.Row>
    </CustomView.Container>
  );
};

export default StudentTiming;
